const ViewPdf = ({ pathOfPdf }) => {
  return <iframe src={pathOfPdf} className=" h-[40rem] w-[100%] lg:w-full" />;
};

export default ViewPdf;
